import * as _ from 'lodash';

import { IAlarmService } from '../../services/index';
import { AlarmList } from '../../models/index';
import { Dispatcher, Dispatch, GetStore } from '../Store';
import * as AT from './alarmTemplate.constants';

export interface IAlarmTemplateActionsService {
    getAll(): Dispatcher<AlarmList>;
}

export class AlarmTemplateActionsService implements IAlarmTemplateActionsService {
    static serviceId = 'alarmTemplateActionsService';
    static $inject = ['$q', 'alarmService'];

    constructor(
        private _$q: angular.IQService,
        private _alarmService: IAlarmService) {
    }

    getAll(): Dispatcher<AlarmList> {
        return (dispatch: Dispatch<AlarmList>, getState: GetStore) => {
            const { alarmTemplates } = getState();
            if (!alarmTemplates.isLoading && !alarmTemplates.isLoaded) {
                dispatch({ type: AT.ALARM_TEMPLATE_LOAD });
                return this._alarmService.getAllForTemplates()
                    .then(data => {
                        dispatch({ type: AT.ALARM_TEMPLATE_LOAD_SUCCESS, payload: data });
                        return data;
                    })
                    .catch((reason) => {
                        dispatch({ type: AT.ALARM_TEMPLATE_LOAD_ERROR, payload: reason });
                        return reason;
                    });
            } else {
                return this._$q.when(_.values<AlarmList>(alarmTemplates.dictionary));
            }
        };
    }
}